import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { LogService } from '../services/log.service';
import { GeneralService } from '../services/general.service';
@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {
  constructor (private user: UserService, private router: Router,
    private general: GeneralService, private auth: AuthService, public log: LogService) { }

  ngOnInit () {
    this.general.clearAllCache();
    this.user.logout().subscribe(data => {
      if (data.success) {
        this.log.addLog({
          action: "Log Out",
          component: "Log Out",
          details: `Logged Out`,
        }).subscribe(data => { });

        this.router.navigate(['/login']);
        this.auth.setLoggedIn(false);
      } else {
        // console.log('an error occurred');
      }
    })
  }

}
